<template>
  <!-- Shown only while at least one active campaign is bidding below its market range.
       Every number here is real auction data - never show this banner on estimates we
       cannot back with the bid-depth replay (see docs/MARKET_CONTEXT_WIRING.md).

       The copy below is UNCHANGED by the 2026-09-04 delivered-calls gate, and that is the
       point: "winnable calls went to other buyers" was an overstatement while the count
       included auctions no call ever arrived on, and it became literally true when the count
       started excluding them. Nothing to edit here - see
       docs/MARKET_CONTEXT_DELIVERED_CALLS.md. -->
  <b-alert
    :show="totalMissedCalls > 0"
    variant="warning"
    class="d-flex align-items-center justify-content-between"
    data-cy="alert-missed-calls"
  >
    <div>
      <font-awesome-icon
        :icon="['fas', 'exclamation-triangle']"
        class="mr-2"
      />
      <strong>{{ totalMissedCalls.toLocaleString() }} winnable calls went to other buyers{{ windowSuffix }}</strong>
      <span class="text-muted">
        across {{ campaignsBelowMarket }} {{ campaignsBelowMarket === 1 ? 'campaign' : 'campaigns' }} bidding below market range.
      </span>
    </div>

    <b-button
      v-b-tooltip.hover
      variant="warning"
      size="sm"
      class="text-nowrap ml-3"
      title="Sorts the table by missed calls so the biggest gaps are on top"
      data-cy="button-review-missed-calls"
      @click="$emit('review')"
    >
      Review below-market bids
    </b-button>
  </b-alert>
</template>

<script>
export default {
  name: 'MissedCallsBanner',

  props: {
    totalMissedCalls: {
      type: Number,
      default: 0
    },

    campaignsBelowMarket: {
      type: Number,
      default: 0
    },

    // The window the missed-call totals were measured over, as the `long` form of
    // formatMarketWindow (e.g. 'last 24 hours', 'last 7 days'). NOT a fixed 24 hours: on
    // Mondays this banner's total covers 7 days and so runs roughly 7x higher, which is the
    // whole reason it has to be stated rather than assumed
    windowLabel: {
      type: String,
      default: ''
    }
  },

  computed: {
    // Rendered bare while the window is unknown. The banner only shows once there are missed
    // calls to report, so in practice the fetch has resolved and the label is present - this
    // is what stops a half-written sentence if it ever isn't
    windowSuffix() {
      return this.windowLabel ? ` in the ${this.windowLabel}` : ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
